export const useStoreVideo = defineStore('StoreVideo', {
    state: () => ({
        video: null,
        error: null,
    }),
    actions: {
        async getVideo(idVideo) {
            this.error = null;
            this.video = null;
            ({video: this.video, error: this.error} = await useEntityVideo().get(idVideo));
        },
    },
});
